<template>
    <div class="base-trumpet-select-fsl" :class="{ 'trsel-sp': $store.state.screen == 1 }">
        <div class="contentfsl">
            <div class="header">
                <div class="left" @click="onBack" v-if="isCloudPlay == 0">
                    <img class="back" src="~images/back.png" />
                    <div class="title">选择小号登陆</div>
                </div>
                <div class="ser" @click="$router.push('/base-trumpet-explain')">小号说明</div>
            </div>
            <div class="content-auto">
                <div class="list" v-for="(item, index) in list" :key="index" @click="toGame(item.app_uid)">
                    <div class="name">
                        <div class="nicName">{{ item.nick_name }}</div>
                        <span v-if="index == 0">【上次登录】</span>
                    </div>
                    <div class="enter">
                        <div>进入游戏</div>
                        <img src="~images/ismove.png" />
                    </div>
                </div>
                <transition name="component-fade" mode="out-in">
                    <TheTips :msg='msg' v-if="msg" />
                </transition>
            </div>
        </div>
        <div class="btn" @click="$router.push('/base-trumpet-add')" v-if="list.length < 10">增加小号</div>
    </div>
</template>

<script>
import TheTips from '@/components/TheTips'

export default {
    name: 'BaseTrumpetSelect',
    components: {
        TheTips
    },
    data() {
        return {
            msg: null,
            list: [],
            loginData: {},
            userData: {},
            /** 云玩1:是云玩,0不是云玩 */
            isCloudPlay: 0,
        }
    },
    methods: {
        onBack() {
            this.$router.push('/base-login?delstatus=' + 1+'&isHasBox='+this.loginData.isHasBox)
        },
        // 进入游戏
        toGame(id) {
            let options = {
                uid: this.userData.data.uid,
                app_uid: id,
                token: this.userData.data.token,
                appid: this.loginData.appid, //渠道ID
                system: this.config.system, //系统
                machine_code: this.loginData.machine_code, //设备号
            };
            options.sign = this.util.getSign(options, this.loginData.appkey);
            options.real_name_verify = 1;   // 是否需要实名验证，1为需要，0为不需要
            this.$axios.post('https://sdk.gameschain.pro/index.php?g=api&m=user&a=check_switch_user', this.$qs.stringify(options)).then(res => {
                if (res.data.status == 1) {
                    this.onLoginSucceed(res.data.data.app_uid, res.data.data.token, res.data.data.uid)
                } else if (res.data.status == 44) { // 返回44  需要进行实名认证
                    this.$router.push('/base-realname?app_uid=' + id)
                } else {
                    this.msg = res.data.msg
                    setTimeout(() => {
                        this.msg = null
                    }, 2000)
                    this.onLoginError(res.data.msg)
                }
            }).catch(o => {
                this.msg = '请求失败'
                setTimeout(() => {
                    this.msg = null
                }, 2000)
            })
        },
        // 进入游戏成功回调
        onLoginSucceed(account, token, uid) {
            let that = this
            if (that.config.system == 2) {
                window.webkit.messageHandlers.wz_callOC.postMessage({
                    method: 'onLoginSucceed',
                    param: {
                        account: account,
                        token: token,
                        uid: uid,
                        status: that.userData.data.is_auth
                    }
                })
            } else {
                window.Android.onLoginSucceed(account, token, uid, that.userData.data.is_auth)
            }
        },
        // 进入游戏失败回调
        onLoginError(error) {
            if (this.config.system == 2) {
                window.webkit.messageHandlers.wz_callOC.postMessage({
                    method: 'onLoginFailed'
                })
            } else {
                window.Android.onLoginFailed(error)
            }
        },
        // 获取小号列表
        getList() {
            let options = {
                uid: this.userData.data.uid,
                appid: this.loginData.appid
            }
            options.sign = this.util.getSign(options, this.loginData.appkey)
            this.$axios.post('https://sdk.gameschain.pro/index.php?g=api&m=userbox&a=app_user_list', this.$qs.stringify(options)).then(res => {
                if (res.data.status == 1) {
                    this.list = res.data.data.list
                }
            })
        }
    },
    created() {
        // 安卓登录
        this.loginData = JSON.parse(sessionStorage.getItem('loginData'))
        this.userData = JSON.parse(sessionStorage.getItem('userData'))
        this.isCloudPlay = this.userData.data.isCloudPlay == 1 ? 1 : 0
        this.getList()

    }
}
</script>

<style lang="scss" scoped>
$color: #FF6C22;

// 横屏css
.base-trumpet-select-fsl {
    width: 864px;
    height: 888px;
    padding-bottom: 60px;
    border-radius: 18px;
    background: rgba(0, 0, 0, 0.8);
    display: flex;
    flex-direction: column;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    transition: all 0.3s;

    .contentfsl {
        flex: 1;
        display: flex;
        flex-direction: column;
        overflow-y: scroll;
    }

    .header {
        height: 132px;
        border-radius: 18px 18px 0 0;
        background: rgba($color, 0.8);
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 60px;

        .left {
            height: 132px;
            display: flex;
            align-items: center;
        }

        .back {
            width: 72px;
            height: 72px;
        }

        .title {
            font-size: 51px;
            text-align: center;
        }

        .ser {
            font-size: 39px;
        }
    }

    .content-auto {
        flex: 1;
        padding: 60px 60px 0;
        overflow-y: scroll;
    }

    .list {
        height: 120px;
        border-radius: 18px;
        background: rgba(255, 255, 255, 0.2);
        padding: 0 45px;
        margin-bottom: 30px;
        display: flex;
        justify-content: space-between;

        .name {
            font-size: 39px;
            height: 120px;
            flex: 1;
            display: flex;
            align-items: center;

            .nicName {
                max-width: 430px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }

            span {
                color: $color;
            }
        }

        .enter {
            color: $color;
            font-size: 33px;
            display: flex;
            align-items: center;

            img {
                width: 36px;
                height: 36px;
                position: relative;
                top: 2px;
                left: 9px;
            }
        }
    }

    .list:first-child {
        .name {
            .nicName {
                max-width: 200px;
            }
        }
    }

    .list:last-child {
        margin-bottom: 60px;
    }

    .btn {
        height: 120px;
        font-size: 39px;
        border-radius: 18px;
        background: $color;
        margin: 0 60px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
}

// 竖屏css
.trsel-sp {
    width: 1570px;
    height: 1614px;
    padding-bottom: 90px;
    border-radius: 32px;

    .header {
        height: 240px;
        border-radius: 32px 32px 0 0;
        padding: 0 90px;

        .left {
            height: 240px;
        }

        .back {
            width: 130px;
            height: 130px;
        }

        .title {
            font-size: 92px;
        }

        .ser {
            font-size: 70px;
        }
    }

    .content-auto {
        padding: 90px 90px 0;
    }

    .list {
        height: 200px;
        border-radius: 32px;
        padding: 0 81px;
        margin-bottom: 54px;

        .name {
            font-size: 70px;
            height: 200px;

            .nicName {
                max-width: 750px;
            }
        }

        .enter {
            font-size: 60px;

            img {
                width: 65px;
                height: 65px;
                top: 3px;
                left: 16px;
            }
        }
    }

    .list:first-child {
        .name {
            .nicName {
                max-width: 370px;
            }
        }
    }

    .list:last-child {
        margin-bottom: 90px;
    }

    .btn {
        height: 200px;
        font-size: 70px;
        border-radius: 32px;
        margin: 0 90px;
    }
}
</style>